module.exports = __webpack_public_path__ + "static/media/LTO-BNB.eb554986.svg";